/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MediaResponse } from '../../models/media-response';

export interface PromptsMediaByPromptGet$Params {
  promptIds: Array<string>;
}

export function promptsMediaByPromptGet(
  http: HttpClient,
  rootUrl: string,
  params: PromptsMediaByPromptGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<MediaResponse>>> {
  const rb = new RequestBuilder(rootUrl, promptsMediaByPromptGet.PATH, 'get');
  if (params) {
    rb.query('promptIds', params.promptIds, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MediaResponse>>;
      }),
    );
}

promptsMediaByPromptGet.PATH = '/prompts/media-by-prompt';
